import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "state";
import { Provider } from "react-redux";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "state/api";
import authReducer from "state/auth";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; // Import named export
import LoadingMessage from "components/LoadingMessage";
import loadingSlice from "state/loadingSlicer";
import errorMessageSlicer from "state/errorMessageSlicer";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'; 
import { FrontDeskManagerProvider } from "components/FrontDeskManager";
import { UserProfileManagerProvider } from "components/UserProfileProvider";
import { SnackbarProvider } from "notistack";
import 'dayjs/locale/de';
import 'dayjs/locale/fr'
import 'dayjs/locale/es'
import 'dayjs/locale/it'
import { MenuManagerProvider } from "components/MenuManager";
import { SilentAlarmProvider } from "components/IntegrationConfigManager";
import { BrowserRouter } from "react-router-dom";

const store = configureStore({
  reducer: {
    global: globalReducer,
    [api.reducerPath]: api.reducer,
    auth: authReducer,
    loading: loadingSlice,
    error: errorMessageSlicer
  },
  middleware: (getDefault) => getDefault().concat(api.middleware),
});
setupListeners(store.dispatch);


//auth reducer
const persistConfig = { key: "root", storage, version: 1 };
const persistedReducer = persistReducer(persistConfig, authReducer);
const storePersist = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

setupListeners(storePersist.dispatch);

// Initialize Day.js with UTC plugin
dayjs.extend(utc);
dayjs.extend(timezone); // Extend Day.js with the timezone plugin

// Get the browser's language preference
const browserLanguage = navigator.language.split('-')[0]; // Extract language code


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
  // <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={browserLanguage}>
      <SnackbarProvider>
      <SilentAlarmProvider>
        <FrontDeskManagerProvider>
          <MenuManagerProvider>
            <PersistGate loading={null} persistor={persistStore(storePersist)}>
              <Provider store={store}>
                      <LoadingMessage/>
                      {/* <ErrorMessage /> */}
                      <BrowserRouter>
                      <UserProfileManagerProvider>
                        <App/>
                      </UserProfileManagerProvider>
                      </BrowserRouter>
              </Provider>
            </PersistGate>
            </MenuManagerProvider>
        </FrontDeskManagerProvider>
      </SilentAlarmProvider>
      </SnackbarProvider>
    </LocalizationProvider>
  // </React.StrictMode>
);

